import type {
  AnalyticsFilter,
  AnalyticsMode,
  ClientsAnalyticsResponse,
  ClientsCitiesResponse,
  ClientsHeatmapResponse,
} from '@crm/shared'
import { apiClient } from './client'

export interface AnalyticsQuery {
  period: 'day' | 'week' | 'month' | 'quarter' | 'year' | 'custom'
  from?: string | null
  to?: string | null
  managerIds: string[]
  filters: AnalyticsFilter[]
}

function serialize(query: AnalyticsQuery): Record<string, string> {
  const params: Record<string, string> = { period: query.period }
  if (query.from) params.from = query.from
  if (query.to) params.to = query.to
  if (query.managerIds.length > 0) params.managerIds = query.managerIds.join(',')
  if (query.filters.length > 0) {
    params.filters = query.filters.map((f) => `${f.mode}:${f.value}`).join(',')
  }
  return params
}

export async function getClientsAnalytics(
  query: AnalyticsQuery & { mode: AnalyticsMode },
): Promise<ClientsAnalyticsResponse> {
  const res = await apiClient.get<{ success: true; data: ClientsAnalyticsResponse }>(
    '/dashboard/clients-analytics',
    { params: { ...serialize(query), mode: query.mode } },
  )
  return res.data.data
}

export async function getClientsHeatmap(query: AnalyticsQuery): Promise<ClientsHeatmapResponse> {
  const res = await apiClient.get<{ success: true; data: ClientsHeatmapResponse }>(
    '/dashboard/clients-heatmap',
    { params: serialize(query) },
  )
  return res.data.data
}

export async function getClientsCities(): Promise<ClientsCitiesResponse> {
  const res = await apiClient.get<{ success: true; data: ClientsCitiesResponse }>(
    '/dashboard/clients-analytics/cities',
  )
  return res.data.data
}

export interface AnalyticsManager {
  id: string
  name: string | null
  email: string
  role: 'MANAGER' | 'ROP'
}

export async function getAnalyticsManagers(): Promise<AnalyticsManager[]> {
  const res = await apiClient.get<{ success: true; data: AnalyticsManager[] }>(
    '/dashboard/clients-analytics/managers',
  )
  return res.data.data
}
